import { Box, IconButton, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { Title } from "../general/typography";
import RefreshIcon from "@mui/icons-material/Refresh";
import * as React from "react";
import AddIcon from "@mui/icons-material/Add";
import PauseIcon from "@mui/icons-material/Pause";
import PlayIcon from "@mui/icons-material/PlayArrow";
import useBackend from "../../hooks/use_backend";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { REACT_QUERY_KEYS } from "../../enums/react_query_key_enum";
import { fetchSiteData } from "../../scripts/api_v2/site_client";
import { CollapsableCard } from "components/general/collapsable_card";

export function JournalctlCard({ tag, setTag, range, setRange, paused, setPaused, refetchJrnlCtl, ...props }) {
  const params = useParams();
  const backend = useBackend();

  return (
    <CollapsableCard
      startCollapsed={true}
      title={"Journalctl " + tag}
      rightAdornment={
        <Stack direction="row" spacing={1}>
          <ToggleButtonGroup
            color="primary"
            value={tag}
            exclusive
            onChange={(v) => (v.target ? setTag(v.target.value) : null)}
          >
            <ToggleButton value="client">Client</ToggleButton>
            <ToggleButton value="bootloader">Bootloader</ToggleButton>
          </ToggleButtonGroup>
          <IconButton onClick={() => setRange(range + 100)}>
            <AddIcon />
          </IconButton>
          <IconButton onClick={() => refetchJrnlCtl()}>
            <RefreshIcon />
          </IconButton>
          <IconButton onClick={() => setPaused(!paused)}>{paused ? <PlayIcon /> : <PauseIcon />}</IconButton>
        </Stack>
      }
      {...props}
    >
      {props.children}
    </CollapsableCard>
  );
}
